import "../../Css/Menu.css";
import { Power, InfoSquare, Phone, Globe2, House, Person, Key, ChatRightText } from "react-bootstrap-icons";
import { Link } from "react-router-dom";
const Menu = (props) => {
  const company = JSON.parse(localStorage.getItem("Company"));
  const { setModalAboutUs } = props
  const logOut = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("LastServiceID");
    localStorage.removeItem("LastServiceType");
    localStorage.removeItem("SystemID");
    localStorage.removeItem("now");
  }
  const closeMenu = () => {
    document.querySelector("input[type='checkbox']").checked = false;
  }
  return (
    <label style={{ color: "black" }}>
      <input type='checkbox' />
      <span className='menu'> <span className='hamburger'></span><span></span><a href="/" onClick={logOut} style={{ fontStyle: "bold", color: "red" }}><Power size={30} /></a></span>
      <div className="menuList">
        {/* <img src="/logo192.png" alt="image" style={{ marginLeft: '10%' }} /> */}
        <div className="row">
          <div className="column">
            <a href={company?.AboutUS}>
              <InfoSquare style={{ marginTop: "6px", color: 'rgb(8 120 110)' }} size={20} />
              <p style={{ marginTop: "6px", color: "black" }}>درباره ما</p>
            </a>
          </div>
          <div className="column">
            <a href={company?.ContactUS}>
              <Phone style={{ marginTop: "6px", color: 'rgb(47 18 161)' }} size={20} />
              <p style={{ marginTop: "6px", color: "black" }}>تماس با ما</p>
            </a>
          </div>
          <div className="column">
            <a href={company?.WebSite}>
              <Globe2 style={{ marginTop: "6px", color: 'rgb(165 21 21)' }} size={20} />
              <p style={{ marginTop: "6px", color: "black" }}>سایت شرکت</p>
            </a>
          </div>
        </div>
        <div className="row">
          <div className="column">
            <Link to='/RequestPassword' onClick={closeMenu}>
              <Key style={{ marginTop: "5px", color: '#ff0094' }} size={24} />
              <p style={{ marginTop: "5px", color: "black" }}>تغییر رمز</p>
            </Link>
          </div>
          <div className="column">
            <Link to='/' onClick={closeMenu}>
              <House style={{ marginTop: "6px", color: '#177759' }} size={22} />
              <p style={{ marginTop: "6px", color: "black" }}>صفحه اصلی</p>
            </Link>
          </div>

          <div className="column">
            <Link to='/Profile' onClick={closeMenu}>
              <Person style={{ marginTop: "6px", color: 'blue' }} size={22} />
              <p style={{ marginTop: "6px", color: "black" }}>پروفایل من</p>
            </Link>
          </div>
        </div>
        <div className="row">
          <div className="column">
          <a href='/'>
            </a>
          </div>
          <div className="column">
            <a href='/' onClick={logOut}>
              <Power style={{ marginTop: "6px", color: 'red' }} size={22} />
              <p style={{ marginTop: "6px", color: "black" }}>خروج</p>
            </a>
          </div>
          <div className="column">
            <a href='/'>
            </a>
          </div>
        </div><div className="row mt-4">
          <div className="column" style={{ backgroundColor: "#dac7d5" }}>
          </div>
          <div className="column" style={{ backgroundColor: "#dac7d5" }}>
            <InfoSquare size={20} style={{ marginTop: "6px", cursor: "pointer" }} color={"rgb(115, 57, 141)"} onClick={() => setModalAboutUs(true)} />
            <p style={{ marginTop: "6px", color: "black", cursor: "pointer" }} onClick={() => setModalAboutUs(true)}>درباره بی همتا</p>
          </div>
          <div className="column" style={{ backgroundColor: "#dac7d5" }}>
          </div>


        </div>
      </div>
    </label>
  )
}

export default Menu;

























// import { Fragment } from "react";
// import "../../Css/Menu.css";
// const Menu = () => {
//   const logOut =()=>{
//       localStorage.removeItem("token");
//   }
//   return (
//     <label>
//       <input type='checkbox' />
//       <span className='menu'> <span className='hamburger'></span> </span>
//       <ul>
//         <li> <a href='https://bihamta.biz/about-us'>درباره ما</a> </li>
//         <li> <a href='https://bihamta.biz/contactus'>تماس با ما</a></li>
//         <li><a href="https://www.instagram.com/hoormah.co/">صفحه اینستاگرام</a></li>
//         <li><a href="https:/bihamta.biz/">وب سایت شرکت</a></li>
//         <li><a href="/" onClick={logOut}>خــروج</a></li>
//       </ul>
//     </label>
//   )
// }

// export default Menu;
